export const button_border_radius = "40px";
export const card_border_radius = "16px";
export const card_padding = "24px";
export const dialog_border_radius = "12px";
export const header_nav_height = "88px";

export const compliance_setting_card_min_width = "688px";
